import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
import MarketsContext from '../../../application/Context/MarketsContext';
import ProjectsContext from '../../../application/Context/ProjectsContext';
export var InfoBar = function (_a) {
    var application = _a.application;
    var context = application == "markets" ? React.useContext(MarketsContext) : React.useContext(ProjectsContext);
    var count = context.count;
    var t = useTranslation(['news']).t;
    return (_jsx("div", { className: "under-filter-info", children: _jsxs("div", { children: [count, " ", t("éléments")] }) }));
};
